var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"folder-caret"},[_c('icon',{attrs:{"size":12,"name":_vm.iconClass}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a988179","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./groups/components/item_caret.vue
// module id = null
// module chunks = 